<template>
  <div>
    <!-- <div class="filterButtonPosition" style="right: 64px">
        <f7-button
          fill
          class="whiteFontColor button-filter"
          panel-toggle="right"
        >
          <span class="ic-filter"></span> {{ $t('filter') }}
        </f7-button>
      </div> -->
    <DxDataGrid
      ref="dataGrid"
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid custom-grid-detail-food-no-rp"
      :no-data-text="$t('noDataTextDetail')"
      @exporting="onExporting"
      @toolbar-preparing="onToolbarPreparing($event)"
      @content-ready="init"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="foodSamplesDetailNoRpTable_v2"
      />
      <DxSelection mode="single" />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="lmr_semaphore"
        caption=""
        header-cell-template="cellTemplateHeaderDots"
        :width="35"
        :allow-sorting="false"
        cell-template="cellTemplateDots"
        :fixed="true"
        fixed-position="left"
      />

      <template #cellTemplateDots="{ data }">
        <div class="dots-parent-container">
          <img
            width="20"
            height="20"
            :src="getDotColorImage(data.value)"
          />
        </div>
      </template>

      <DxColumn
        data-field="parameter_group"
        :caption="$t('group')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parameter"
        :caption="$t('foodSamples.parameter')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="result_value"
        :caption="$t('foodSamples.result')"
        alignment="left"
        :calculate-cell-value="calculateResultValue"
        :customize-text="customizeResultText"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="unit_value"
        :caption="$t('foodSamples.unit')"
        alignment="left"
        :calculate-cell-value="calculateUnitValue"
        :allow-header-filtering="false"
      />

      <DxColumn
        :caption="$t('foodSamples.range')"
        alignment="left"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateRange"
      />

      <DxColumn
        :caption="$t('cma')"
        data-field="cma_value"
        alignment="left"
        :allow-header-filtering="false"
        :calculate-cell-value="calculateCma"
      />

      <DxExport :enabled="true" />
      <template #cellTemplateHeaderDots="{ data }">
        <div>
          <PopUp position="top">
            <div style="padding: 10px">
              <div class="pop-up-info">
                <img
                  :src="getDotImage('grey')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('foodSamples.detailNotRP.greyDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('green')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('foodSamples.detailNotRP.greenDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('red')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{
                    $t('foodSamples.detailNotRP.redDotDescription')
                  }}
                </div>
              </div>
              <div class="pop-up-info">
                <img
                  :src="getDotImage('orange')"
                  width="15"
                  height="15"
                />
                <div style="padding-left: 5px">
                  {{ $t('foodSamples.summary.orangeDotDescription') }}
                </div>
              </div>
            </div>
          </PopUp>
        </div>
      </template>
    </DxDataGrid>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import {
  DxDataGrid,
  DxColumn,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
  DxExport,
  DxSelection,
  DxSearchPanel,
} from 'devextreme-vue/data-grid';

import saveAs from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import PopUp from '@/components/UtilityComponents/popUpInfo/popUp.vue';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxExport,
    DxSelection,
    DxSearchPanel,
    PopUp,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState('samples', ['reportSampleCode']),
  },
  methods: {
    getDotImage(color) {
      return require(`../../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    getGridInstance() {
      return this.$refs.dataGrid?.instance || null;
    },
    getGridInstance() {
      return this.$refs.dataGrid?.instance || null;
    },
    getDotColorImage(color) {
      return require(`../../../../../../assets/dot-colors/${color}_new.svg`)
        .default;
    },
    defaultNoValue() {
      return 0;
    },
    init(e) {
      this.setSampleDetails(e.component.getDataSource().items());
    },
    calculateRange(rowData) {
      return `${rowData.value.r_min} - ${rowData.value.r_max}`;
    },
    calculateResultValue(rowData) {
      return rowData?.value?.ResultadoPresentacion ?? '';
    },
    calculateUnitValue(rowData) {
      return rowData?.value?.unit ?? '';
    },
    customizeResultText(cellInfo) {
      return cellInfo.valueText?.includes('En Proceso')
        ? this.$t('inProcess')
        : cellInfo.valueText;
    },
    calculateCma(rowData) {
      return rowData.cma?.[0]?.CMASuperior ?? '';
    },
    onExporting(e) {
      e.component.beginUpdate();
      e.component.columnOption('ID', 'visible', true);
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet(
        this.$t('foodSamples.exportExcelNoRpName')
      );

      exportDataGrid({
        component: e.component,
        worksheet,
      })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(
              new Blob([buffer], {
                type: 'application/octet-stream',
              }),
              `besafer-${this.reportSampleCode}.xlsx`
            );
          });
        })
        .then(() => {
          e.component.columnOption('ID', 'visible', false);
          e.component.endUpdate();
        });

      e.cancel = true;
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'after';
        }
        if (item.name === 'exportButton') {
          item.location = 'after';
        }

        // if (item.name === 'groupPanel') {
        //   item.location = 'after';
        // }
      });

      toolbarItems.push({
        name: 'Filtros',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: '',
          icon: '././static/icons/ic_filter.svg',
          width: 40,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });
    },
    ...mapActions('foodSamples', ['setSampleDetails']),
  },
};
</script>

<style>
.custom-grid-detail-food-no-rp .dx-searchbox {
  width: 200px !important;
}
.custom-grid-detail-food-no-rp .dx-toolbar-after {
  display: grid;
  grid-template-columns: 100px 107px 48px 37px;
  grid-template-rows: repeat(1, 1fr);
  row-gap: 24px;
  align-items: center;
  box-sizing: border-box;
}
.custom-grid-detail-food-no-rp .dx-toolbar-after :nth-child(1) {
  grid-row: 1;
  grid-column: 4;
}
.custom-grid-detail-food-no-rp .dx-toolbar-after :nth-child(2) {
  grid-row: 1;
  grid-column: 1 / span 2;
}
.custom-grid-detail-food-no-rp .dx-toolbar-after :nth-child(3) {
  grid-row: 1;
  grid-column: 3;
  justify-self: start;
}

.custom-grid-detail-food-no-rp .dx-toolbar-after .dx-button {
  width: 40px !important;
  height: 40px !important;
}
</style>
